import React from "react";
import { LaunchTile_m365App$data } from "./__generated__/LaunchTile_m365App.graphql";
import { TileContextMenu_tileContextMenu$key } from "./__generated__/TileContextMenu_tileContextMenu.graphql";
import { PinStateChangeHandler } from "./LaunchTile.types";
import { graphql } from "./taggedNode";
export interface TileContextMenuCallbacks {
  /**
   * The callback that is triggered when an App Tile is launched out into a new tab or window.
   *
   * @memberof TileContextMenuProps
   */
  onLaunchOut?: (ev: React.SyntheticEvent) => void;
  /**
   * The callback that is triggered when the user asks for more information about an App Tile.
   *
   * @memberof TileContextMenuProps
   */
  onGetMoreInfo?: (ev: React.SyntheticEvent) => void;
  /**
   * The callback that is triggered when the user pins or unpins an App Tile.
   *
   * @type {PinStateChangeHandler}
   * @memberof TileContextMenuProps
   */
  onPinStateChange?: PinStateChangeHandler;
  /**
   * The callback that is triggered when the user invokes a custom action in an App Tile.
   *
   * @memberof TileContextMenuProps
   */
  onCustomAction?: (
    ev: React.SyntheticEvent,
    eventType: string,
    eventData: string
  ) => void;
  /**
   * The callback that is triggered when the user uninstalls an App Tile.
   *
   * @memberof TileContextMenuProps
   */
  onUninstall?: (ev: React.SyntheticEvent) => void;
  /**
   * An array of custom actions that can be triggered on an App Tile.
   *
   * @type {CustomAction[]}
   * @memberof TileContextMenuProps
   */
  customActions: M365ApplicationSecondaryActions;
  /**
   * The pinning position of the App Tile.
   *
   * @type {number}
   * @memberof TileContextMenuProps
   */
  pinnedIndex?: number;
}
/**
 * Props for the context menu control for an App Tile.
 *
 * @export
 * @interface TileContextMenuProps
 */
export interface TileContextMenuProps {
  /**
   * The context menu control model from the host.
   *
   * @type {LaunchTile_tileContextMenu$key}
   * @memberof TileContextMenuProps
   */
  tileContextMenu: TileContextMenu_tileContextMenu$key;
  /**
   * The ID of the App Tile.
   *
   * @type {string}
   * @memberof TileContextMenuProps
   */
  targetAppTileId: string;
  /**
   * Allows host to specify additional inline styling of the tile context menu control.
   *
   * @type {(React.CSSProperties | undefined)}
   * @memberof TileContextMenuProps
   */
  style?: React.CSSProperties | undefined;
  /**
   * The target HTML element that is used to anchor the context menu's positioning.
   */
  menuTarget: HTMLElement | undefined;
  /**
   * The callbacks associated with the menu items in the context menu.
   */
  menuItemCallbacks: TileContextMenuCallbacks;
  /**
   * Indicates whether the context menu should be in the opened state.
   */
  contextMenuOpen: boolean;
  /**
   * Sets the context menu open state for the parent host.
   */
  setContextMenuOpen: (open: boolean) => void;
}
export const modelFragment = graphql`
  fragment TileContextMenu_tileContextMenu on TileContextMenu {
    openInNewTabItemLabel
    aboutAppItemLabel
    unpinAppItemLabel
    pinAppItemLabel
    uninstallAppItemLabel
  }
`;
type M365ApplicationSecondaryActions =
  LaunchTile_m365App$data["secondaryActions"];
